import { Box } from "@chakra-ui/react";

export const Footer = () => {
  return (
    <Box mt="2rem" p="1rem">
      &copy; Martin Bíško 2023
    </Box>
  );
};
